import React from 'react';
import './NotificationPopup.scss';

const NotificationPopup = ({ nome, slot, onClose }) => {
  return (
    <div className="popup notification-popup">
      <div className="notification-content">
        <span className="notification-title">Hora da medicação</span>
        <span className="notification-nome">{nome}</span>
        <span className="notification-slot">{slot}</span>
        <button className="ok-btn" onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default NotificationPopup; 